import directives from './directive';

const MyDirective = Object.create(null);

MyDirective.install = function (Vue) {
  for (const key in directives) {
    Vue.directive(key, directives[key]);
  }
};
export default MyDirective;



// WEBPACK FOOTER //
// ./src/directive/index.js